export default __webpack_public_path__ + "static/media/fintech-icon-01.04c09e47.svg";